import { DeletionRequestPanel } from './DeletionRequestPanel';
import { useState } from 'react';
import { Link } from 'react-router';
import { AdminPageHeader } from '../../../../components/AdminPageHeader';
import { ADMIN_DELIVERY_ZONES_PATH, ADMIN_DELIVERY_ZONE_LIVE_MAP_PATH } from '../../adminRoutes';
import { CurrentMapPanel } from './CurrentMapPanel';
import { GenerationDetail } from './GenerationDetail';
import { GenerationStartControl } from './GenerationStartControl';
import { GenerationHistory } from './GenerationHistory';
import './generations.css';

export function GenerationPage() {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  return (
    <section className="admin-page map-generations">
      <AdminPageHeader
        title="Генерации карты"
        eyebrow="Логистика"
        description="История запусков и подтверждённая опубликованная версия — независимые данные."
        actions={(
          <>
            <Link className="workspace-secondary-button" to={ADMIN_DELIVERY_ZONES_PATH}>
              Реестр и опубликованная карта
            </Link>
            <Link className="workspace-secondary-button" to={ADMIN_DELIVERY_ZONE_LIVE_MAP_PATH}>
              Текущие границы
            </Link>
          </>
        )}
      />
      <CurrentMapPanel />
      <DeletionRequestPanel showDetail={selectedId === null} open={() => setSelectedId(null)} />
      <GenerationStartControl select={setSelectedId} />
      <GenerationHistory select={setSelectedId} />
      {selectedId && <GenerationDetail id={selectedId} />}
    </section>
  );
}
